<template>
  <div
    v-if="profile">
    <div
      class="d-flex align-items-center"
      @click="onClickItem">
      <user-avatar
        :user="profile"
        size="lg" />
      <div
        class="d-flex flex-column justify-content-center pl-2 flex-grow-1">
        <div class="d-flex justify-content-between">
          <p
            class="members__name pt-2">
            {{ profile.name }}
          </p>
          <div
            class="mb-2"
            @click.stop="$router.push('/settings')">
            <span class="side-nav__icon material-icons text-white">
              settings
            </span>
          </div>
        </div>
        <div class="d-flex justify-content-between">
          <p
            class="members__team">
            {{ profile.position }}
          </p>
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserAvatar from '@/components/parts/UserAvatar.vue'
export default {
  components: {
    UserAvatar
  },
  filters: {
    substring(v, end = 1) {
      if (!v) return ''
      return v.substring(0, end)
    }
  },
  props: {
    profile: {
      type: Object,
      default: null
    }
  },
  methods: {
    onClickItem() {
      this.$router.push(`/members/${this.profile.id}`, () => {})
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/members';
</style>